export enum EquipmentTypeId {
  BICICLETA = 1,
  BICICLETA_ELETRICA = 2,
  AUTOPROPELIDO = 3,
  CICLOMOTOR_MOTO_ELETRICA = 4
}

export type EquipmentValue = 'bike' | 'ebike' | 'escooter' | 'scooter';

const searchNameEquipment = (name: string): string => {
  switch (name) {
    case 'bike':
      return 'Bicicleta';
    case 'ebike':
      return 'Bicicleta elétrica';
    case 'escooter':
      return 'Autopropelido';
    case 'scooter':
      return 'Ciclomotor e Moto Elétrica';
    default:
      return 'Não escolhido';
  }
};

export const searchNameEquipmentId = (name: string): EquipmentTypeId => {
  switch (name) {
    case 'bike':
      return EquipmentTypeId.BICICLETA;
    case 'ebike':
      return EquipmentTypeId.BICICLETA_ELETRICA;
    case 'escooter':
      return EquipmentTypeId.AUTOPROPELIDO;
    case 'scooter':
      return EquipmentTypeId.CICLOMOTOR_MOTO_ELETRICA;
    default:
      return EquipmentTypeId.BICICLETA;
  }
};

export const searchEquipmentNameById = (id: number): EquipmentValue => {
  switch (id) {
    case EquipmentTypeId.BICICLETA:
      return 'bike';
    case EquipmentTypeId.BICICLETA_ELETRICA:
      return 'ebike';
    case EquipmentTypeId.AUTOPROPELIDO:
      return 'escooter';
    case EquipmentTypeId.CICLOMOTOR_MOTO_ELETRICA:
      return 'scooter';
    default:
      return 'bike';
  }
};

export const getEquipmentIdFromType = (equipmentType: string): EquipmentTypeId => {
  const normalizedType = equipmentType?.toLowerCase().trim() || '';

  if (normalizedType.includes('ciclomotor') || normalizedType.includes('moto el')) {
    return EquipmentTypeId.CICLOMOTOR_MOTO_ELETRICA;
  }

  if (normalizedType.includes('autopropelido') || normalizedType.includes('patinete')) {
    return EquipmentTypeId.AUTOPROPELIDO;
  }

  if (normalizedType.includes('bicicleta el') || normalizedType === 'ebike') {
    return EquipmentTypeId.BICICLETA_ELETRICA;
  }

  if (normalizedType.includes('bicicleta') || normalizedType === 'bike') {
    return EquipmentTypeId.BICICLETA;
  }

  return EquipmentTypeId.BICICLETA;
};

export default searchNameEquipment;
